// Shared helpers for status presentation

export function statusBadgeClass(status) {
  const v = String(status || '').toLowerCase()
  if (v === 'approved' || v === 'completed' || v === 'active' || v === 'finished') return 'bg-[#d1e7dd] text-[#0f5132] border border-[#badbcc]'
  if (v === 'pending' || v === 'in_progress') return 'bg-[#fff3cd] text-[#664d03] border border-[#ffecb5]'
  if (v === 'cancelled' || v === 'canceled' || v === 'rejected' || v === 'deactivated') return 'bg-[#fde2e0] text-[#6b1513] border border-[#cf524e]'
  return 'bg-neutral-100 text-neutral-900 border border-neutral-300'
}

export default { statusBadgeClass }
